// Angular imports
import { Component, OnInit, OnDestroy } from '@angular/core';

// Import services

// Import rxjs
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/state-management/app-state';
import { undoRedo } from 'src/app/app.module';

@Component({
    selector: 'undo-redo',
    templateUrl: './undo-redo.component.html',
    styleUrls: ['./undo-redo.component.scss'],
    standalone: false
})
export class UndoRedoComponent implements OnInit, OnDestroy {
    public _counterUndo = 0;
    public _counterRedo = 0;
    public _canUndo: boolean = false;
    public _canRedo: boolean = false;

    private subscriptions: Subscription[] = [];

    constructor(private store: Store<AppState>) {
        this._canUndo = false;
        this._canRedo = false;

        undoRedo.queueUpdated$.subscribe(()=>{
            this.update();
            // console.log('QUEUE', undoRedo.past);
        })
    }

    private update(){
        this._canUndo = undoRedo.past.length > 0;
        this._canRedo = undoRedo.future.length > 0;
        this._counterUndo = undoRedo.past.length;
        this._counterRedo = undoRedo.future.length;
    }

    public ngOnInit(): void {
        this.update();
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }

    public undo() {
        undoRedo.handleCalculationUndo(this.store);
    }

    public redo() {
        undoRedo.handleCalculationRedo(this.store);
    }
}
